import { FC, useEffect, memo, useCallback, useRef, MutableRefObject, useState } from "react";
import AdminPage from "../AdminPage";
import { AppThunk } from "../../store";
import { apiClient } from "../../utils/apiClient";
import { useParams } from "react-router-dom";

const RenderField = ({ name, value, onChange, onSave }: any) => {


  if (value && typeof value === 'object') {
    return (
      <div>
        {/* <strong>{name}:</strong> */}
        {Object.keys(value).map((key) => (
          <RenderField key={key} name={`${name}.${key}`} value={value[key]}
            onSave={onSave} onChange={(val: any) => onChange({ ...value, [key]: val })} />
        ))}
      </div>
    );
  }
  return (
    <div>
      {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
      <label>{name}: <textarea value={value} onChange={(e) => onChange(e.target.value)} /></label>
      {/* eslint-disable-next-line react/button-has-type */}
      <button onClick={() => onSave(name, value)}>Save</button>
    </div>
  );
};

export type Props = {};

const DocumentEditor = (props: Props) => {
  const { collectionName, documentId } = useParams()
  const [doc, setDocument] = useState<any>({});
  const docFieldRef = useRef<HTMLInputElement>(null);
  const docValueRef = useRef<HTMLInputElement>(null);

  const handleSave = async (field: string, val: any) => {
    await await apiClient.post(`/mongo/edit/${collectionName}/${documentId}`, {
      field_name: field,
      value: val
    });
  };

  useEffect(() => {
    const fetchDocument = async () => {
      try {
        const response = await apiClient.post(`/mongo/edit/${collectionName}/${documentId}`);
        if (response) {
          setDocument(response);
        }
      } catch (error) {
        console.error('Error fetching document:', error);
      }
    };
    fetchDocument();
  }, [collectionName, documentId]);


  const handleChange = (key: string, value: any) => {
    setDocument((prevDocument: any) => ({
      ...prevDocument,
      [key]: value
    }));
  };

  return (
    <AdminPage>
      <div>
        {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
        <label>fieldName: <input type="text" ref={docFieldRef} /></label>
        {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
        <label>fieldValue: <input type="text" ref={docValueRef} /></label>
        {/* eslint-disable-next-line react/button-has-type */}
        <button onClick={() => handleSave(docFieldRef.current?.value as string, docValueRef.current?.value as string)}>Save</button>
      </div>
      {Object.keys(doc).map((key: string) => (
        <RenderField
          key={key}
          name={key}
          value={doc[key]}
          onChange={(value: any) => handleChange(key, value)}
          onSave={handleSave} />
      ))}

    </AdminPage>
  );
};

// server-side data here
export const loadData = (): AppThunk[] => [];

export default memo(DocumentEditor);
